<template>
    <fb-main-body>你无权访问该页面</fb-main-body>
</template>

<script>
    export default {
        name: "Home"
    }
</script>

<style scoped>

</style>